<template>
    <div>
        <tx-history v-bind:address="address" v-if="currentComponent === 'tx-history'" />

        <tx-simple v-bind:address="address" v-if="currentComponent === 'tx-simple'"
            v-bind:shouldLoadPendings="shouldLoadPendings"
        />
    </div>
</template>

<script>
import TxHistory from './TxHistory.vue';
import TxSimple from './TxSimple.vue';

export default {
    name: 'tx-root',
    props: {
        address: {
            type: String,
            required: false,
        },
        shouldLoadPendings: {
            type: Boolean,
        },
    },

    data() {
        return {
            currentComponent: undefined,
        };
    },

    components: {
        TxHistory,
        TxSimple,
    },

    mounted() {
        this.updateCurrentComponent(this.$store.state.transactionViewData);
    },

    watch: {
        '$store.state.transactionViewData': function (newVal) {
            this.updateCurrentComponent(newVal);
        },
    },

    methods: {
        updateCurrentComponent(value) {
            if (value === 'professional') {
                this.currentComponent = 'tx-history';
            } else if (value === 'simple') {
                this.currentComponent = 'tx-simple';
            }
        },
    },
};
</script>
